import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-fixture",
    styleUrls: ["./fixture.component.scss"],
    templateUrl: "./fixture.component.html"
})
export class FUIFixtureComponent {
    @Input() @HostBinding("class.wrappable") public wrappable: boolean;
}
